var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ik-data-table',{attrs:{"entity-name":_vm.$t('unit'),"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }